import * as Yup from 'yup'

const MerchantInventoryBatchProcessItemSchema = Yup.object().shape({
  sku: Yup.string().required('Required')
})

export default MerchantInventoryBatchProcessItemSchema
